export default __webpack_public_path__ + "static/media/NYAH & Foundation of the NYAH - Website update.d9bfd85a.pdf";